import { render, staticRenderFns } from "./HeaderLanguagenavigation.vue?vue&type=template&id=bcda2dae"
import script from "./HeaderLanguagenavigation.vue?vue&type=script&lang=js"
export * from "./HeaderLanguagenavigation.vue?vue&type=script&lang=js"
import style0 from "./HeaderLanguagenavigation.vue?vue&type=style&index=0&id=bcda2dae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports